<template>
  <v-dialog
    v-model="isOpen"
    max-width="700"
    @input="handleClose"
  >
    <v-card>
      <v-card-title class="headline pb-10">
        Вы точно хотите удалить выбранного партнера {{currentFirebase.name}}?
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text @click="close()">Закрыть</v-btn>
        <v-btn text color="primary" @click="deleteFirebase">Удалить</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import OverlayLoader from '@/app/shared/components/app-loader/Loader';

export default {
  name: 'confirmDeletionModal',
  components: {
    OverlayLoader,
  },
  data() {
    return {
    };
  },
  computed: {
    isOpen: {
      get(){
        return this.$store.getters.GET_FIREBASES_DETAILS_MODAL_CONFIRM_DELETION;
      },
      set(){
        this.$store.commit('SET_CONFIRM_DELETION_FIREBASE_MODAL', false);
      }
    },
    currentFirebase: {
      get(){
        return this.$store.getters.GET_CURRENT_FIREBASE;
      },
      set(value){
        this.$store.commit("SET_CURRENT_FIREBASE", value);
      }
    },
  },
  methods: {
    handleClose(isOpen) {
      if (!isOpen) {
        this.close();
      }
    },
    close() {
      this.$store.commit('SET_CURRENT_FIREBASE', {});
      this.$store.commit('SET_CONFIRM_DELETION_FIREBASE_MODAL_LOADING', false);
      this.isOpen = false;
    },
    deleteFirebase(){
      this.$store.dispatch('DELETE_FIREBASE', this.currentFirebase.id)
        .then(() => {
          this.$toast.success('Firebase был удалён');
          this.close();
        })
        .catch(() => {
          this.$toast.error('Неизвестная ошибка');
        });
    }
  },
};
</script>
